(() => {
  if (window.XZContent) return;
  const equipment = {'激光系列':'laser','CNC系列':'cnc','拆屏系列':'separator','保压系列':'pressure','除泡系列':'debubbling','加热台系列':'heating','辅助设备':'bench','切膜附件':'film'};
  const accessory = {'SIM卡槽':'sim','排线':'flex','Xwitzeal产品配件':'xwitzeal','螺丝刀':'screwdrivers','刮胶刀':'adhesive-scrapers','镊子':'tweezers'};
  const focus = {'电路板':'board','屏幕':'screen','电池':'battery','手机后盖':'back-glass'};
  const typeLabels = {laser:'Laser machines',cnc:'CNC machines',separator:'Screen separators',pressure:'Pressure holding',debubbling:'Bubble removal',heating:'Heating platforms',bench:'Auxiliary equipment',film:'Film cutting / X1 attachment'};
  const guideLabels = {'安装与入门':'Setup & getting started','操作教程':'Operation','保养维护':'Care & maintenance','故障排查':'Troubleshooting'};
  const cache = new Map();
  function localURL(href, params = {}) {
    const url = new URL(href, location.origin);
    if (url.origin !== location.origin) throw new Error('Unexpected content source');
    for (const [key,value] of Object.entries(params)) url.searchParams.set(key,value);
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    return url.pathname + url.search + url.hash;
  }
  async function pages(href) {
    const result = [], seen = new Set();
    let next = localURL(href,{view:'xz-content-feed'});
    while (next) {
      if (seen.has(next)) throw new Error('Repeated content page');
      seen.add(next);
      const response = await fetch(next,{credentials:'same-origin',signal:AbortSignal.timeout(15000)});
      if (!response.ok) throw new Error('Content unavailable');
      const data = await response.json();
      if (!Array.isArray(data.items)) throw new Error('Invalid content page');
      result.push(...data.items);
      next = data.next ? localURL(new URL(data.next,new URL(next,location.origin)).href,{view:'xz-content-feed'}) : null;
    }
    return result;
  }
  function load(href) {
    if (!cache.has(href)) cache.set(href,pages(href).catch(error => {cache.delete(href);throw error;}));
    return cache.get(href);
  }
  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function picture(src, alt) {
    if (!src) return null;
    const url = new URL(src,location.origin);
    if (url.protocol !== 'https:') return null;
    const img = el('img'); img.src = url.href; img.alt = alt; img.loading = 'lazy'; img.width = 700; img.height = 700;
    return img;
  }
  function productCard(item) {
    const card = el('article','xz-product');
    Object.assign(card.dataset,{xzProduct:'',handle:item.handle,focus:'',series:'',accessory:'',kind:'',price:item.price,title:item.title});
    const imageLink = el('a','xz-product__image'); imageLink.href = localURL(item.url);
    const img = picture(item.image,item.title); if(img) imageLink.append(img);
    const body = el('div','xz-product__body'), heading = el('h3'), link = el('a','',item.title);
    link.href = imageLink.href; heading.append(link);
    const bottom = el('div','xz-product__bottom'); bottom.append(el('span','',item.money + (item.available ? '' : ' · Sold out')));
    body.append(heading,bottom);card.append(imageLink,body);return card;
  }
  function learnCard(item, category) {
    const card = el('a','xz-learn-card'); card.href=localURL(item.url,{view:'xz-learn'});
    Object.assign(card.dataset,{xzLearnCard:'',handle:item.handle,category});
    const image=el('div','xz-learn-card__image'), img=picture(item.image,item.title);
    if(img) image.append(img); image.append(el('span','','GUIDES & SUPPORT'));
    const copy=el('div','xz-learn-card__copy');
    copy.append(el('span','xz-eyebrow',typeLabels[category]),el('h3','',item.title),el('p','','Find available guides, product details and model-specific support.'),el('span','xz-learn-card__cta','Explore this model ↗'));
    card.append(image,copy);return card;
  }
  async function syncCatalog() {
    const roots = [...document.querySelectorAll('[data-xz-learning],[data-xz-finder],[data-xz-tool-catalog]')].filter(root=>!root.dataset.contentReady);
    if(!roots.length) return;
    roots.forEach(root=>root.dataset.contentReady='loading');
    try {
      const items = await load((window.Shopify?.routes?.root || '/')+'collections/all');
      for(const root of roots) {
        if(root.matches('[data-xz-learning]')) {
          root.dispatchEvent(new Event('xz:catalog-updating'));
          const grid=root.querySelector('.xz-learning__cards'), select=root.querySelector('[data-xz-learn-select]');
          for(const item of items) {
            let card=[...grid.querySelectorAll('[data-xz-learn-card]')].find(node=>new URL(node.href).pathname===item.url);
            let option=[...select.options].find(node=>new URL(node.value,location.origin).pathname===item.url);
            if(item.learning===false) {card?.remove();option?.remove();continue;}
            if(!card && item.learning!==true) continue;
            const category=equipment[item.equipment] || card?.dataset.category || 'bench';
            if(!card){card=learnCard(item,category);grid.append(card);}
            card.dataset.category=category;
            let group=[...select.querySelectorAll('optgroup')].find(node=>node.dataset.category===category);
            if(!group){group=el('optgroup');group.label=typeLabels[category];group.dataset.category=category;select.append(group);}
            if(!option){option=el('option','',item.title);option.value=localURL(item.url,{view:'xz-learn'});option.dataset.guideReady='dynamic';}
            group.append(option);
          }
          root.dispatchEvent(new Event('xz:catalog-updated'));
        } else if(root.matches('[data-xz-finder]')) {
          const grid=root.querySelector('[data-xz-product-grid]');
          for(const item of items) {
            let card=[...grid.querySelectorAll('[data-xz-product]')].find(node=>node.dataset.handle===item.handle);
            const category=equipment[item.equipment], part=accessory[item.accessory];
            if(!card && !category && !part && !item.focus?.length) continue;
            if(!card){card=productCard(item);grid.append(card);}
            if(category) {card.dataset.series=category;card.dataset.kind='equipment';}
            if(part) {card.dataset.accessory=part;card.dataset.kind='parts';}
            if(Array.isArray(item.focus)) card.dataset.focus=item.focus.map(value=>focus[value]).filter(Boolean).join(' ');
          }
          root.dispatchEvent(new Event('xz:catalog-updated'));
        } else {
          const grid=root.querySelector('[data-xz-tools-grid]'), category=root.dataset.xzToolCatalog;
          const types=category ? [category] : ['screwdrivers','adhesive-scrapers','tweezers'];
          for(const item of items.filter(item=>types.includes(accessory[item.accessory]))) {
            if(![...grid.querySelectorAll('a')].some(link=>new URL(link.href).pathname===item.url)) grid.append(productCard(item));
          }
          if(grid.children.length) root.querySelector('[data-xz-tools-empty]')?.setAttribute('hidden','');
        }
        root.dataset.contentReady='true';
      }
    } catch {
      roots.forEach(root=>{delete root.dataset.contentReady;});
      // Existing server-rendered products remain available if a request fails.
    }
  }
  function articleCard(item) {
    const card=el('a','xz-content-card');card.href=localURL(item.url);
    const img=picture(item.image,item.title);if(img) card.append(img);
    const body=el('div','xz-content-card__body');
    body.append(el('span','xz-eyebrow',guideLabels[item.type] || 'Product guide'),el('h3','',item.title),el('p','',item.excerpt),el('span','xz-text-link','Read guide ↗'));
    card.append(body);return card;
  }
  async function initGuides(root) {
    if(root.dataset.contentReady)return;
    root.dataset.contentReady='loading';
    const status=root.querySelector('[data-guide-status]'), grid=root.querySelector('[data-guide-grid]');
    try {
      const items=await load(root.dataset.guideSource), handle=root.dataset.product;
      const matches=handle ? items.filter(item=>item.products.includes(handle)) : items;
      const search=root.querySelector('[data-guide-search]'), filter=root.querySelector('[data-guide-type]');
      function render() {
        const query=(search?.value || '').trim().toLowerCase(),type=filter?.value || '';
        const visible=matches.filter(item=>(!type || item.type===type) && (!query || (item.title+' '+item.excerpt+' '+item.products.join(' ')).toLowerCase().includes(query)));
        grid.replaceChildren(...visible.map(articleCard));
        status.textContent=visible.length ? `${visible.length} ${visible.length===1?'guide':'guides'}` : matches.length ? 'No guides match this search.' : root.dataset.replaceLegacy==='true' ? 'New guides are being prepared. Explore the introduction below or contact our technical team.' : 'New guides are being prepared. Contact our technical team for model-specific instructions.';
      }
      search?.addEventListener('input',render);filter?.addEventListener('change',render);render();
      root.querySelector('[data-guide-pagination]')?.setAttribute('hidden','');
      if(matches.length && root.dataset.replaceLegacy==='true') {
        root.hidden=false;
        document.querySelector('[data-xz-legacy-guide]')?.setAttribute('hidden','');
      }
      root.dataset.contentReady='true';
    } catch {
      status.textContent=grid.children.length ? 'Browse the available guides below. Search is temporarily unavailable.' : 'Guides could not load. Please refresh, or use the product introduction and support links below.';
      delete root.dataset.contentReady;
    }
  }
  function init() {syncCatalog();document.querySelectorAll('[data-xz-guides]').forEach(initGuides);}
  window.XZContent={load,localURL,equipment,accessory,focus};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
